import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Select2Data } from 'ng-select2-component';
import { ChatbotClientDTO } from '../models/chatbot-client-dto';
import { DataTablesResponse } from '../models/datatables';

@Injectable({
  providedIn: 'root'
})

export class ChatbotClientService {

  private pathAPI = environment.urlAPI;
  private controller = "ChatbotClient/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<ChatbotClientDTO> {
    return this.http.get<ChatbotClientDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: ChatbotClientDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: ChatbotClientDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }
    
  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable', data);
  } 

  public getAllForSelect(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetAllForSelect');
  }
}
